import { get } from '../../utils/object-helpers';

import authGuarantee from "<ebay-authenticity-guarantee-24-fit-icon>";
import certifiedRefurb from "<ebay-authenticity-guarantee-24-fit-icon>"; // Same icon as authGuarantee
import clickToCall from "<ebay-click-to-call-24-fit-icon>";
import ebayPlus from "<ebay-ebay-plus-24-fit-icon>";
import escrow from "<ebay-escrow-24-fit-icon>";
import warranty from "<ebay-free-warranty-24-fit-icon>";
import moneyBackCHF from "<ebay-legacy-money-back-guarantee-chf-48-colored-icon>";
import moneyBackEU from "<ebay-legacy-money-back-guarantee-eu-48-colored-icon>";
import moneyBackUK from "<ebay-legacy-money-back-guarantee-uk-48-colored-icon>";
import moneyBackUS from "<ebay-legacy-money-back-guarantee-us-48-colored-icon>";
import moneyBackZL from "<ebay-legacy-money-back-guarantee-zl-48-colored-icon>";
import topRatedSeller from "<ebay-top-rated-seller-24-fit-icon>";
import vault from "<ebay-the-ebay-vault-24-fit-icon>";

$ {
    const BADGE_MAP = {
        AUTHORIZED_SELLER: authGuarantee,
        BUSINESS_EQUIPMENT_PURCHASE_PROTECTION: null,
        CERTIFIED_REFURBISHED: certifiedRefurb,
        SWC_CALL_THE_SELLER: clickToCall,
        DIAL_PHONE_CALL: clickToCall,
        EBAY_MONEY_BACK_GUARANTEE_EURO: moneyBackEU,
        EBAY_MONEY_BACK_GUARANTEE_POUND: moneyBackUK,
        EBAY_MONEY_BACK_GUARANTEE_DOLLAR: moneyBackUS,
        FREE_WARRANTY: warranty,
        PROTECTED_PAYMENT: null,
        AUTHENTICITY: authGuarantee,
        AUTHENTICITY_GUARANTEE: authGuarantee,
        SWC_TOP_RATED_PLUS: topRatedSeller,
        VEHICLE_PURCHASE_PROTECTION: null
    }
    const headingId = 'quickviewDialogHeading';
    const errorImg = 'https://pics.ebaystatic.com/aw/pics/nextGenVit/imgNoImg.gif';
    const onImageError = `if (this.src !== '${errorImg}') this.src = '${errorImg}';`;
}

<if(state.open)>
    <ebay-lightbox-dialog
        class="str-quickview"
        on-close("closeDialog")
        open=state.open
        aria-labelledby=headingId
        a11y-close-text=state.closeDialogText>

        <if(state.errorMessage)>
            <div class="str-quickview__loading-error">
                <ebay-section-notice status="attention">
                    <div role="alert">${state.errorMessage}</div>
                </ebay-section-notice>
            </div>
        </if>
        <else>
            <div class="str-quickview__body">
                <div class="str-quickview__media">
                    <div class="str-quickview__hero-image-wrap">
                        <!--==================
                        // Hero image
                        ======================-->
                        <img class="str-quickview__hero-image"
                            on-load("onHeroImageLoad")
                            onerror=onImageError
                            alt=state.heroImage && state.heroImage.title
                            src=state.heroImage && state.heroImage.url/>

                        <if(state.quickviewWatch)>
                            <str-watch-icon
                                page=input.page
                                quickviewWatch=state.quickviewWatch
                                hasVariations=state.hasVariations
                                itemId=state.itemId
                                variationId=state.variationId
                                isVariationWatched=state.isWatching
                                iconSize='MEDIUM' />
                        </if>
                    </div>
                    <div class="str-quickview__thumb-carousel-wrap" on-blur("onCarouselBlur") on-mouseleave("onCarouselMouseleave")>
                        $ {
                            const prevText = get(state, 'carousel.prevText', '');
                            const nextText = get(state, 'carousel.nextText', '');
                            const prevAndNextTracking = get(state, 'carousel.prevAndNextTracking', '');
                            let hasMoreThanOneImage = false;
                            if (state.mediaList && state.mediaList.length) {
                                const images = state.mediaList.filter(media => media.mediaType === 'IMAGE');
                                hasMoreThanOneImage = images.length > 1;
                            }
                        }
                        <!--==================
                        // Thumb carousel
                        ======================-->
                        <str-quickview-carousel
                            a11y-previous-text=prevText
                            a11y-next-text=nextText
                            tracking-previous=prevAndNextTracking
                            tracking-next=prevAndNextTracking>

                            <if(hasMoreThanOneImage)>
                                <for|media, index| of=state.mediaList>
                                    $ {
                                        const mediaType = get(media, 'mediaType', '');
                                        const thumbUrl = get(media, 'image.thumbnail.URL', '');
                                        const imageId = get(media, 'image.thumbnail.imageId', '');
                                        const tracking = JSON.stringify(get(media, 'trackingMap.IMAGE_FILMSTRIP_THUMBS_CLICK', ''));
                                        const title = get(media, 'image.thumbnail.title', '');
                                    }
                                    <if(mediaType === 'IMAGE')>
                                        <@item key=`thumb_${index}`>
                                            <button
                                                on-mouseover("onThumbMouseover", imageId)
                                                on-focus("onThumbFocus", imageId)
                                                on-click("onThumbClick", imageId)
                                                data-image-id=imageId
                                                data-track=tracking
                                                class="str-quickview__thumb">

                                                <img on-load("onThumbLoad") alt=title src=thumbUrl onerror=onImageError/>
                                                <ebay-progress-spinner
                                                    class="str-quickview__thumb__spinner"
                                                    size="small"
                                                    aria-label=input.spinnerText/>
                                            </button>
                                        </@item>
                                    </if>
                                </for>
                            </if>
                            <else>
                                <@item>
                                    <div class="str-quickview__thumb-carousel-spacer waiting"></div>
                                </@item>
                            </else>
                        </str-quickview-carousel>
                    </div>
                </div>
                <div class="str-quickview__content">
                    <!--==================
                    // Item details
                    ======================-->
                    <if(state.titleTag)>
                        <div class="str-quickview__title-tag">
                            <str-listing-text-span ...state.titleTag/>
                        </div>
                    </if>
                    <h2 id=headingId class="str-quickview__title">
                        <if(state.title)>
                            <a href=state.title.url data-track=state.title.tracking target="_blank">
                                ${state.title.text}
                            </a>
                        </if>
                    </h2>
                    <if(state.condition)>
                        <div class="str-quickview__condition">
                            ${state.condition}
                        </div>
                    </if>
                    <if(state.price)>
                        <div class="str-quickview__price" aria-live="polite">
                            <if(state.price.seePrice)>
                                <a class="str-quickview__see-price"
                                    href=state.price.seePrice.url
                                    data-track=state.price.seePrice.tracking
                                    target="_blank">

                                    <span class="clipped">${state.price.seePrice.altText}</span>
                                    <span>${state.price.seePrice.text}</span>
                                </a>
                            </if>
                            <else>
                                <if(state.price.label)>
                                    <span class="str-quickview__price__label">${state.price.label}</span>
                                </if>
                                ${state.price.text}
                            </else>
                            <if(state.price.baseUnitPrice)>
                                <span class="str-quickview__price__bup">${state.price.baseUnitPrice}</span>
                            </if>
                        </div>
                        <if(state.price.strikeThrough)>
                            <div>
                                <if(state.price.strikeThrough)>
                                    <span class="str-quickview__price__strike-through" aria-live="polite">
                                        <str-text-span ...state.price.strikeThrough/>
                                    </span>
                                </if>
                                <if(state.price.percentOff)>
                                    <span class="str-quickview__price__percent-off" aria-live="polite">
                                        <str-text-span ...state.price.percentOff/>
                                    </span>
                                </if>
                            </div>
                        </if>
                    </if>
                    <if(state.shippingReturns)>
                        <div class="str-quickview__shipping-returns">
                            ${state.shippingReturns}
                        </div>
                    </if>
                    <if(state.eek)>
                        <div class="str-quickview__eek">
                            <str-eek ...state.eek />
                        </div>
                    </if>
                    <if(state.eekTire)>
                        <div class="str-quickview__eek-tire">
                            <str-eek-tire ...state.eekTire pointer="right-top" />
                        </div>
                    </if>
                    <!-- For now, don't allow add-to-cart for items with Customization or Auction -->
                    <if(!state.customization && !state.hasAuction && state.cartButton)>
                        <div class="str-quickview__menu-group">
                            $ {
                                let menuOutOfStock;
                                let outOfStockHtmlId;
                                if (state.menus && state.menus.length) {
                                    menuOutOfStock = state.menus.find(menu => menu.error && menu.error.type === 'OUT_OF_STOCK');
                                    if (menuOutOfStock) {
                                        outOfStockHtmlId = 'out-of-stock-error';
                                    }
                                }
                            }
                            <if(menuOutOfStock)>
                                <div class="error out-of-stock" id=outOfStockHtmlId aria-live="polite">${menuOutOfStock.error.message}</div>
                            </if>
                            <!--==================
                            // Aspect menus
                            ======================-->
                            <if(state.menus && state.menus.length)>
                                <for|menu, i| of=state.menus>
                                    <if(menu.items)>
                                        $ {
                                            let menuHtmlId = menu.error ? `qkvw-menu-${menu.id}-${Date.now()}` : '';
                                            menuHtmlId = outOfStockHtmlId || menuHtmlId;
                                            const menuKey = `aspmenu_${menu.id}_${i}`;
                                        }
                                        <div key=menuKey class="str-quickview__menu">
                                            <ebay-listbox-button
                                                aria-invalid=(!!menu.error).toString()
                                                aria-describedby=menuHtmlId
                                                role="button"
                                                name=menu.id
                                                fluid=true
                                                truncate=true
                                                prefix-label=`${menu.displayLabel}: `
                                                on-change("onSelectAspect", menu.id)>

                                                <if(menu.defaultDisplayValue)>
                                                    <@option text=menu.defaultDisplayValue/>
                                                </if>
                                                <for|item, ii| of=menu.items>
                                                    <if(item.isValidForCombo)>
                                                        $ {
                                                            const isOutOfStock = item.outOfStock || item.isComboOutOfStock;
                                                            const optionText = isOutOfStock ? `${item.displayName} ${menu.outOfStockLabel}` : item.displayName;
                                                            const itemKey = `aspmenuitm_${menu.id}_${ii}`;
                                                        }
                                                        <@option
                                                            key=itemKey
                                                            text=optionText
                                                            value=item.valueId
                                                            selected=(menu.selectedValueId === item.valueId)/>
                                                    </if>
                                                </for>
                                            </ebay-listbox-button>
                                            <!--
                                            // Don't show out-of-stock error messages here.
                                            // Show a single out-of-stock error message on top of all the aspect menus.
                                            -->
                                            <if(menu.error && menu.error.type !== 'OUT_OF_STOCK')>
                                                <div class="error" id=menuHtmlId aria-live="polite">${menu.error.message}</div>
                                            </if>
                                        </div>
                                    </if>
                                </for>
                            </if>
                            <!--==================
                            // Quantity menu
                            ======================-->
                            <if(state.quantity)>
                                <div class="str-quickview__menu">
                                    <span class="quantity field">
                                        <label class="field__label field__label--start" for="quantity">
                                            ${state.quantity.label}
                                        </label>
                                        <ebay-textbox
                                            type="number"
                                            invalid=!!state.quantity.error
                                            aria-describedby="quantity-error"
                                            id="quantity"
                                            name="quantity"
                                            min=1
                                            max=state.quantity.max
                                            fluid=true
                                            value=state.quantity.selected
                                            on-change("onSelectQuantity")
                                        />
                                    </span>
                                    <if(state.quantity.error)>
                                        <div class="error" id="quantity-error" aria-live="polite">${state.quantity.error.message}</div>
                                    </if>
                                </div>
                            </if>
                        </div>
                    </if>
                    <if(state.confidence)>
                        <div class="str-quickview__confidence">
                            $ {
                                const badgeComp = BADGE_MAP[state.confidence.iconName];
                            }
                            <if(badgeComp)>
                                <${badgeComp}/>
                            </if>
                            <div class="str-quickview__confidence-text">
                                <div>${state.confidence.title}</div>
                                <div>${state.confidence.body}</div>
                            </div>
                        </div>
                    </if>
                    <!--==================
                    // Add-to-cart and View item buttons
                    ======================-->
                    <div class="str-quickview__buttons">
                        <!-- For now, don't allow add-to-cart for items with Customization -->
                        <if(!state.customization && state.cartButton)>
                            <if(state.cartButton.type === 'addToCart')>
                                <ebay-button
                                    class="str-quickview__add-to-cart-btn"
                                    size="large"
                                    on-click("onAddToCartClick")
                                    data-track=state.cartButton.tracking
                                    priority="primary">${state.cartButton.label}</ebay-button>
                            </if>
                            <else>
                                 <ebay-button
                                    class="str-quickview__add-to-cart-btn"
                                    size="large"
                                    href=state.cartButton.url
                                    data-track=state.cartButton.tracking
                                    priority="primary">${state.cartButton.label}</ebay-button>
                            </else>
                        </if>
                        <if(state.viewItemButton)>
                            <ebay-button
                                class="str-quickview__view-item-btn"
                                size="large"
                                href=state.viewItemButton.url
                                data-track=state.viewItemButton.tracking
                                target="_blank"
                                priority="secondary">${state.viewItemButton.label}</ebay-button>
                        </if>
                    </div>
                </div>
            </div>
            <!--==================
            // Spinner
            ======================-->
            <div class="str-quickview__spinner">
                <ebay-progress-spinner
                    class="str-quickview__spinner-icon"
                    size="large"
                    aria-live="polite"
                    aria-label=input.spinnerText/>
                <div class="str-quickview__spinner-mask"/>
            </div>
        </else>
    </ebay-lightbox-dialog>
</if>
